/* Divine Apothecary — interactions */
(function () {
  "use strict";

  /* Sticky header state */
  var header = document.querySelector(".site-header");
  function onScroll() {
    if (!header) return;
    if (window.scrollY > 40) header.classList.add("scrolled");
    else header.classList.remove("scrolled");
    var _cue = document.querySelector(".scroll-cue"); if (_cue) _cue.style.opacity = window.scrollY > 40 ? "0" : "1";
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* Mobile nav */
  var toggle = document.querySelector(".menu-toggle");
  var mobile = document.querySelector(".mobile-nav");
  if (toggle && mobile) {
    toggle.addEventListener("click", function () {
      mobile.classList.toggle("open");
      document.body.style.overflow = mobile.classList.contains("open") ? "hidden" : "";
    });
    mobile.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () {
        mobile.classList.remove("open");
        document.body.style.overflow = "";
      });
    });
  }

  /* Scroll reveal */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: "0px 0px -10% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
    requestAnimationFrame(function () {
      revealEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) * 0.98) el.classList.add("in");
      });
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add("in"); });
  }

  /* Toast helper */
  function toast(msg) {
    var t = document.getElementById("toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "toast";
      t.className = "toast";
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }
  window.daToast = toast;

  /* Add-to-cart / gift mockups (showcase only) */
  document.querySelectorAll("[data-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var name = btn.getAttribute("data-cart") || "Ritual";
      toast("Added to sanctuary — " + name);
    });
  });

  /* Waitlist (sold-out) mockup */
  document.querySelectorAll("[data-waitlist]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var name = btn.getAttribute("data-waitlist") || "this ritual";
      toast("Added to the waitlist — " + name);
    });
  });

  /* Quantity stepper (supports both a <span> mock and a native <input name=quantity>) */
  document.querySelectorAll(".qty").forEach(function (q) {
    var val = q.querySelector(".qty-val") || q.querySelector("span");
    if (!val) return;
    var isInput = val.tagName === "INPUT";
    function get() { return parseInt(isInput ? val.value : val.textContent, 10) || 1; }
    function set(n) { if (isInput) { val.value = n; } else { val.textContent = n; } }
    q.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        var n = get() + (b.dataset.step === "up" ? 1 : -1);
        if (n < 1) n = 1;
        set(n);
      });
    });
  });

  /* Product gallery thumbnails (prefers hi-res data-full) */
  var mainImg = document.getElementById("pd-main-img");
  if (mainImg) {
    document.querySelectorAll(".pd-thumbs button").forEach(function (b) {
      b.addEventListener("click", function () {
        document.querySelectorAll(".pd-thumbs button").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        mainImg.src = b.dataset.full || b.querySelector("img").src;
      });
    });
  }

  /* Native variant selection — update price + active state */
  document.querySelectorAll(".denoms input[name='id']").forEach(function (r) {
    r.addEventListener("change", function () {
      var group = r.closest(".denoms");
      if (group) group.querySelectorAll(".denom").forEach(function (l) { l.classList.remove("active"); });
      if (r.parentElement) r.parentElement.classList.add("active");
      var price = document.getElementById("pd-price");
      if (price && r.dataset.price) price.textContent = r.dataset.price;
    });
  });

  /* Gift card denomination selector */
  document.querySelectorAll(".denoms").forEach(function (group) {
    var amount = document.getElementById("gc-amount");
    group.querySelectorAll(".denom").forEach(function (b) {
      b.addEventListener("click", function () {
        group.querySelectorAll(".denom").forEach(function (x) { x.classList.remove("active"); });
        b.classList.add("active");
        if (amount && b.dataset.val) amount.textContent = "A$" + b.dataset.val;
      });
    });
  });

  /* Contact form (showcase only) */
  var form = document.getElementById("contact-form");
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      toast("Message received — we will reply with reverence");
      form.reset();
    });
  }

  /* Footer year */
  var y = document.getElementById("year");
  if (y) y.textContent = new Date().getFullYear();

  /* Homepage Voices of Renewal rotator (3 featured, cycles through all). */
  (function voicesRotator(){
    var wrap=document.querySelector('[data-voices-rotator]');
    var dataEl=document.querySelector('[data-voices-data]');
    if(!wrap||!dataEl) return;
    var items; try{items=JSON.parse(dataEl.textContent);}catch(e){return;}
    if(!items.length) return;
    var per=3,i=0;
    function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
    function card(it){return '<div class="voice"><div class="voice-head"><span class="voice-mono">'+esc(it.mono)+'</span><span class="voice-name">'+esc(it.name)+'</span></div><p class="q">'+esc(it.quote)+'</p></div>';}
    function render(){var h='';for(var k=0;k<per;k++){h+=card(items[(i+k)%items.length]);}wrap.innerHTML=h;}
    render();
    if(items.length>per){setInterval(function(){wrap.classList.add('is-fading');setTimeout(function(){i=(i+per)%items.length;render();wrap.classList.remove('is-fading');},560);},6000);}
  })();

  /* Orphan / widow control: bind the last two words of headings and body
     copy with a non-breaking space so no line is left a single lone word.
     Complements CSS text-wrap: balance/pretty for cases the browser cannot
     resolve on its own (e.g. a long final word). */
  (function widont() {
    var SEL = [
      "h1", "h2", "h3", "h4", "h5", "h6",
      ".eyebrow", ".kicker", ".tagline", ".lead", ".serif-lead", ".sub", ".motto",
      ".section-head p", "blockquote", "cite",
      ".pcard h3", ".pcard .desc", ".accord h4", ".accord p",
      ".da-rich-hero__title", ".da-pw__title", ".da-pw__message",
      ".rte p", ".da-rich p", ".da-rich li", ".footer-brand p",
      ".urr-buy__desc", ".urr-home__body p"
    ].join(",");
    var MAX_PAIR = 26;
    try {
      document.querySelectorAll(SEL).forEach(function (el) {
        if (el.getAttribute("data-widont") === "1") return;
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var node, target = null, pos = -1;
        while ((node = walker.nextNode())) {
          var s = node.nodeValue;
          for (var i = s.length - 1; i >= 0; i--) {
            if (s.charCodeAt(i) === 32 && /\S/.test(s.slice(i + 1))) { target = node; pos = i; break; }
          }
        }
        if (target && pos >= 0) {
          var t = target.nodeValue;
          var after = (t.slice(pos + 1).match(/^\S+/) || [""])[0];
          var before = (t.slice(0, pos).match(/(\S+)\s*$/) || ["", ""])[1];
          if (before.length + after.length + 1 <= MAX_PAIR) {
            target.nodeValue = t.slice(0, pos) + "\u00A0" + t.slice(pos + 1);
          }
        }
        el.setAttribute("data-widont", "1");
      });
    } catch (e) { }
  })();
})();
